<div class="content content-fixed">
  <div class="container">
    <div class="text-xl mb-3 normal-case">{{ pageTitle }}</div>
    <form [formGroup]="cashCageForm" class="w-full flex flex-wrap bg-white rounded-md shadow-lg p-4">
      <div class="grid grid-cols-2 gap-1 w-full md:grid-cols-1">
        <div class="grid grid-cols-2 gap-0.5 w-full">
          <div *ngFor="let field of rightFormFields" class="w-full px-2 mb-2">
            <label [for]="field.controlName" class="block text-xs font-normal mb-1"> {{ field.label }}: </label>
            <input [id]="field.controlName" [formControlName]="field.controlName" [type]="field.type"
              class="w-full text-sm border border-gray-300 rounded-md px-0.5 py-0.5 focus:border-black focus:outline-none hover:border-black"
              [placeholder]="field.placeholder" [maxlength]="field.maxLength" [pattern]="field.pattern"
              (input)="validateNumberInput($event, field.controlName)"
              (paste)="preventPaste($event, field.controlName)" [ngClass]="{
                'border-red-500':
                  cashCageForm.get(field.controlName).invalid && cashCageForm.get(field.controlName).touched
              }" />
          </div>
        </div>
        <div class="grid grid-cols-2 gap-0.5 w-full">
          <div *ngFor="let field of leftFormFields" class="w-full px-2 mb-2">
            <label [for]="field.controlName" class="block text-xs font-normal mb-1"> {{ field.label }}: </label>
            <input [id]="field.controlName" [formControlName]="field.controlName" [type]="field.type"
              class="w-full text-sm border border-gray-300 rounded-md px-0.5 py-0.5 focus:border-black focus:outline-none hover:border-black"
              [placeholder]="field.placeholder" [maxlength]="field.maxLength" [pattern]="field.pattern"
              (input)="validateNumberInput($event, field.controlName)"
              (paste)="preventPaste($event, field.controlName)" [ngClass]="{
                'border-red-500':
                  cashCageForm.get(field.controlName).invalid && cashCageForm.get(field.controlName).touched
              }" />
          </div>
        </div>
      </div>
      <div class="flex w-full justify-between p-2 flex-wrap">
        <button type="button" class="btn btn-default px-3 py-1 border rounded-md text-sm" (click)="clearForm()">
          Clear Form
        </button>
        <div class="flex gap-3">
          <button type="button" class="px-3 py-1 border btn btn-default rounded-md text-sm" (click)="Documents()">
            Execute IDV Screening
          </button>
          <button type="button" class="px-3 py-1 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm"
            (click)="Screen()">
            Screen
          </button>
        </div>
      </div>
    </form>
    <div class="w-full h-auto  bg-white mt-4 rounded-md flex flex-col" *ngIf="cashCageDetails && condents">
      <div class="w-full h-16 border-b-2 flex flex-col">
        <h1 class="w-full  ml-4 h-10 flex items-center text-xl font-bold ">{{cashCageDetails.firstname}} {{cashCageDetails.lastname}}</h1>
        <div class=" ml-4"></div>
      </div>
      <div class="w-full flex gap-2 pl-2 border-b-2 p-1">
        <div class="flex  items-center bg-white p-2 rounded-md" *ngFor="let item of condents">
          <div [ngClass]="getStatusClass(item.Status)" class="px-4 py-2 rounded-md text-center">
            {{ item.Status }}
          </div>
          <div class="ml-4 cursor-pointer" (click)="openApiData(item)">
            {{ item.APIName }}
          </div>
        </div>
      </div>
      <div *ngIf="selectionApi">
        <div>
          <h1 class="text-xl font-bold ml-2">Selection Api : {{selectionApi.APIName}}</h1>
        </div>
        <div *ngFor="let item of selectionApi" class="m-1 ml-4 gap-2">
          <!-- <div *ngFor="let header of item.headers" class="flex font-serif">
            <div class="w-1/6">
              {{ header }}
            </div>
            <div class="w-1/6">
              : {{ item.contents[header] }}
            </div>
          </div> -->
        </div>
      </div>

  </div>
  <div *ngIf="scanning" style="z-index: 1000"
    class="p-2 fixed inset-0 flex items-top justify-center bg-black bg-opacity-25 backdrop-blur-md">
    <div class="w-3/5 h-1/2 bg-[#DBD6CE] border flex flex-col items-center py-4 rounded-lg shadow-lg">
      <div class="w-full h-1/6 justify-between flex px-2">
        <h1 class="font-bold text-2xl">IDV Screening</h1>
        <p class="cursor-pointer text-xl font-bold -mt-5 top-0" (click)="closeScanning()">✖</p>
      </div>
      <div *ngIf="!selfie" class="w-full h-5/6 flex justify-around items-center gap-5 bg-white py-2">
        <div (click)="scanningID('scan_front')"
          class="w-1/3 h-3/5 cursor-pointer flex flex-col justify-center items-center gap-2">
          <img *ngIf="!imgFront" src="../../assets/img/front-of-id-card.png" alt="Waiting Scanned Document" />
          <img *ngIf="imgFront" [src]="imgFront" alt="Scanned Document" class="w-full h-full" />
          <h1 class="font-bold text-xl">Scan front Side</h1>
        </div>
        <div (click)="scanningID('scan_back')"
          class="w-1/3 h-3/5 cursor-pointer flex flex-col justify-center items-center gap-2">
          <img *ngIf="!imgBack" src="../../assets/img/id-do-back.png" alt="Waiting Scanned Document" />
          <img *ngIf="imgBack" [src]="imgBack" alt="Scanned Document" class="w-full h-full" />
          <h1 class="font-bold text-xl">Scan back Side</h1>
        </div>
      </div>
      <div *ngIf="!selfie" class="w-full h-1/6 flex justify-end px-4 items-center gap-4">
        <button (click)="closeScanning()" class="p-2">Cancel</button>
        <button class="px-3 py-1 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm" (click)="updatesImgs()">
          IDV Screen
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="isScaningLoad" style="z-index: 1001"
    class="p-2 fixed inset-0 flex flex-col items-center justify-center bg-black bg-opacity-25 backdrop-blur-md">
    <div *ngIf="isScanningSide === 'scan_front'" class="scanner_f">
      <div class="scan-line"></div>
    </div>
    <div *ngIf="isScanningSide === 'scan_back'" class="scanner_b">
      <div class="scan-line"></div>
    </div>
  </div>
  <app-spinner *ngIf="isLoading"></app-spinner>
</div>